import { Controller } from "@hotwired/stimulus"
import { filterRangeOptions } from "../utils/range_filter_utils"

export default class extends Controller {
  static targets = ["minInput", "maxInput"]

  connect() {
    filterRangeOptions(this.minInputTarget, this.maxInputTarget)
  }

  validate(event) {
    const minRaw = this.minInputTarget.value
    const maxRaw = this.maxInputTarget.value

    if (minRaw !== "" && maxRaw !== "") {
      const minVal = parseInt(minRaw)
      const maxVal = parseInt(maxRaw)
      if (!isNaN(minVal) && !isNaN(maxVal) && minVal > maxVal) {
        if (event.target === this.minInputTarget) {
          this.#setValue(this.maxInputTarget, minRaw)
        } else {
          this.#setValue(this.minInputTarget, maxRaw)
        }
      }
    }

    filterRangeOptions(this.minInputTarget, this.maxInputTarget)
  }

  #setValue(el, value) {
    const ts = el.tomselect
    if (ts) {
      ts.setValue(value, true)
    } else {
      el.value = value
    }
  }
}
